import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { loadKustomerChat } from 'utils/loadChatKustomer';

const KustomerChat = () => {
  const user = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (user) {
      loadKustomerChat(user, null, false);
    }
  }, [user]);

  return <div id="kustomer-chat" />;
};

export default KustomerChat;
